import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  'cls-1': (props: any) => ({
    fill: props.filterBackgroundColor || whiteColor,
  }),
  'cls-2': {
    fill: 'url(#Градієнт_без_назви_10)',
  },
  'cls-3': (props: any) => ({
    fill: props.preloaderColor || props.primaryColor,
  }),
  'cls-3-1': {
    animation: '$widthLabel1 500ms infinite alternate',
  },
  'cls-3-2': {
    animation: '$widthLabel2 700ms infinite alternate',
  },
  'cls-3-3': {
    animation: '$widthLabel3 800ms infinite alternate',
  },
  '@keyframes widthLabel1': {
    from: { width: 0 },
    to: { width: 25.5 },
  },
  '@keyframes widthLabel2': {
    from: { width: 0 },
    to: { width: 25.5 },
  },
  '@keyframes widthLabel3': {
    from: { width: 0 },
    to: { width: 25.5 },
  },
  wrapperLoader: {
    borderRadius: '50%',
    width: '50px',
    height: '50px',
  },
  fullSize: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    height: '100%',
  },
}));
